import { render, staticRenderFns } from "./BusinessContent.vue?vue&type=template&id=2e8ebe76&scoped=true&"
import script from "./BusinessContent.vue?vue&type=script&lang=js&"
export * from "./BusinessContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ebe76",
  null
  
)

export default component.exports